import React from "react";
import keys from "../../myData/keys.js";
import { useLanguage } from "../../Context/LanguageContext";
import "../MobileNavbar/MobileNavbar.css";
import navbarKeys from "../../myData/keys.js";
import { NavLink } from "react-router-dom";

function MobileNavbar() {
  const { language, setLanguage, setIsNavbarOpen } = useLanguage();

  return (
    <div className="Mobile-navbar-container">
      <div className="mobile-languages-buttons">
        {Object.keys(navbarKeys).map((language, index) => (
          <li
            key={index}
            onClick={() => {
              setLanguage(language);
              setIsNavbarOpen(false);
            }}
          >
            {language === "arabic"
              ? "عربي"
              : language === "dutch"
              ? "Nederlands"
              : language === "english"
              ? "English"
              : ""}
          </li>
        ))}
      </div>
      <div className="mobile-navbar-keys">
        {keys[language].map((key, index) => (
          <li key={index} onClick={() => setIsNavbarOpen(false)}>
            <NavLink
              className="navbar-key"
              to={`/${navbarKeys.english[index].toLowerCase()}`}
            >
              {key}
            </NavLink>
          </li>
        ))}
      </div>
    </div>
  );
}

export default MobileNavbar;
